<div id="bisherigePersoenlicheVerhaeltnisseAngaben">

    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEPERSOENLICHEVERHAELTNISSE.TITEL' | translate }}</h2>

    <div class="mb-5x">

        <h5 class="mb-3x">
            {{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEPERSOENLICHEVERHAELTNISSE.ZUGEZOGEN.BISHERIGEADRESSE_TITEL' | translate }}
        </h5>

        <div class="form-check mb-3x">
            <input
                    type="checkbox"
                    class="form-check-input"
                    id="isZugezogen"
                    [(ngModel)]="isZugezogen"
                    [disabled]="readonly"
                    (ngModelChange)="clearFreuhereAdresse($event)">
            <label class="form-check-label" for="isZugezogen">
                {{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEPERSOENLICHEVERHAELTNISSE.ZUGEZOGEN.TITEL' | translate }}
            </label>
        </div>

        <common-ui-bisherige-adresse *ngIf="isZugezogen" [(data)]="data.bisherigeAdresse"
                                     [readonly]="readonly">
        </common-ui-bisherige-adresse>

    </div>

    <div class="mb-5x">

        <div class="d-flex justify-content-between mb-3x">
            <h5>
                {{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEPERSOENLICHEVERHAELTNISSE.STEUERNUMMER.BISHERIGESTEUERNUMMER_TITEL' | translate }}
            </h5>
            <common-ui-daten-uebernahme (picked)="onEstSteuernummerPicked($event)"
                                        [itemTemplate]="datenuebernahmeEstSteuernummer"
                                        [items]="stammdaten?.antragsteller?.estSteuernummer" [readonly]="readonly"
                                        context="AntragstellerEstSteuernummer"></common-ui-daten-uebernahme>
        </div>

        <div class="form-check mb-3x">
            <input
                    type="checkbox"
                    class="form-check-input"
                    id="hasEstSteuernummer"
                    [(ngModel)]="hasEstSteuernummer"
                    [disabled]="readonly"
                    (ngModelChange)="clearSteuernummerInput($event)">
            <label class="form-check-label" for="hasEstSteuernummer">
                {{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEPERSOENLICHEVERHAELTNISSE.STEUERNUMMER.TITEL' | translate }}
            </label>
        </div>

        <div *ngIf="hasEstSteuernummer">
            <common-ui-steuernummer [(data)]="data.estSteuernummer" [readonly]="readonly"
                                    index="0"></common-ui-steuernummer>


            <div class="mt-3x">
                <div class="form-row mb-3x">
                    <div class="col-sm-12 col-lg-12 d-flex common-ui-switch-parent">
                        <common-ui-switch
                                id="switchSteuernummerEhepartner"
                                [(checked)]="showSteuernummerEhepartner"
                                [readonly]="readonly"
                                (checkedChange)="clearPartnerSteuernummerInput($event)">
                        </common-ui-switch>
                        <h5>{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEPERSOENLICHEVERHAELTNISSE.ESTEHEPARTNER.TITEL' | translate }}</h5>
                    </div>
                </div>
                <common-ui-steuernummer
                        *ngIf="showSteuernummerEhepartner"
                        [(data)]="data.estSteuernummerEhepartner"
                        [readonly]="readonly"
                        index="1">
                </common-ui-steuernummer>
            </div>
        </div>

    </div>

</div>

<ng-template #datenuebernahmeEstSteuernummer let-item="item">
    <h4 class="list-group-item-heading">
        {{ 'COMMON_UI.STEUERNUMMER.FINANZAMTNUMMER' | translate }} {{item?.finanzamtnummer}}
        <br>
        {{ 'COMMON_UI.STEUERNUMMER.STEUERNUMMER' | translate }}
        {{ getSteuernummerMask(item?.finanzamtnummer).prefix }}{{ item?.steuernummer | mask: getSteuernummerMask(item?.finanzamtnummer).mask }}
    </h4>
</ng-template>
